import React, { ReactNode } from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";

import { NotificationSeverity } from "../../shared/enums/notification-severity";

interface IProps {
  title: string;
  message: string | ReactNode;
  severity: NotificationSeverity;
  onClose: () => void;
  onSuccess: (err?: Error | null) => void;
  /** true — только «ОК» и крестик (информационное окно), без «Да»/«Нет». */
  confirmOnly?: boolean;
}

export const ConfirmDialog = (props: IProps): React.JSX.Element => {
  const { title, message, onSuccess, onClose, severity, confirmOnly = false } = props;

  const acknowledgeHandler = () => {
    onSuccess();
    onClose();
  };

  const cancelHandler = () => {
    onSuccess(new Error("User cancelled"));
    onClose();
  };

  const handleClose = confirmOnly ? acknowledgeHandler : cancelHandler;

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ pr: 6 }}>
        {title}
        <IconButton
          aria-label="закрыть"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {typeof message === "string" ? (
          <DialogContentText
            id="alert-dialog-description"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {message}
          </DialogContentText>
        ) : (
          <div id="alert-dialog-description">{message}</div>
        )}
      </DialogContent>
      <DialogActions>
        {confirmOnly ? (
          <Button onClick={acknowledgeHandler} color={severity} variant="contained">
            ОК
          </Button>
        ) : (
          <>
            <Button onClick={cancelHandler} color={severity}>
              Нет
            </Button>
            <Button onClick={acknowledgeHandler} color={severity} variant="contained">
              Да
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
